module.exports = __webpack_public_path__ + "img/doors2.0fec4d4f.jpg";